export default "__VITE_ASSET__CJkMkrnl__"